import { useNavigate, useParams } from "react-router-dom";
import { useWorkspace } from "../../hooks/useWorkspace";

export function Subscription() {
  const { workspaceId = "" } = useParams<{ workspaceId: string }>();
  const navigate = useNavigate();
  const ws = useWorkspace(workspaceId);

  const planName = "Pax8 plan";
  const memberships = ws.data?.memberships ?? [];
  const seatCount = memberships.filter((m) => m.acceptedAt !== null).length;

  return (
    <div className="main-inner" data-testid="subscription">
      <div className="greet-row">
        <span className="greet">Subscription</span>
        <span className="greet-date">BILLING · PAX8</span>
      </div>
      <div className="subgreet">
        <div className="section-eyebrow">Plan, usage, and BYO model</div>
        <div className="lede">
          Subscriptions are managed through Pax8. Detailed billing UI ships in
          V1.1.
        </div>
      </div>

      {/* Plan card */}
      <div
        style={{
          marginTop: 18,
          border: "1px solid var(--accent-soft)",
          borderRadius: 10,
          background:
            "linear-gradient(135deg, white 0%, var(--accent-soft) 200%)",
          padding: "20px 24px",
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr",
          gap: 24,
          alignItems: "center",
        }}
        data-testid="subscription-plan-card"
      >
        <div>
          <div
            style={{
              fontSize: 11,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: "var(--accent)",
              fontWeight: 600,
            }}
          >
            CURRENT PLAN
          </div>
          <div style={{ fontSize: 22, fontWeight: 600, marginTop: 4 }}>
            {planName}
          </div>
          <div
            style={{ fontSize: 12, color: "var(--text-3)", marginTop: 4 }}
            data-testid="subscription-billing-source"
          >
            Provisioned via Pax8 marketplace
          </div>
        </div>
        <div>
          <div
            style={{
              fontSize: 10.5,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "var(--text-3)",
              fontWeight: 600,
            }}
          >
            Seats used
          </div>
          <div
            style={{ fontSize: 18, fontWeight: 600, marginTop: 4 }}
            data-testid="subscription-seats"
          >
            {seatCount}
          </div>
          <div style={{ fontSize: 11, color: "var(--text-3)" }}>
            Active memberships
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <button
            type="button"
            className="btn"
            disabled
            title="Coming in V1.1"
            data-testid="subscription-manage-disabled"
          >
            Manage plan (V1.1)
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => navigate(`/workspaces/${workspaceId}/agents`)}
            data-testid="subscription-byo-link"
          >
            BYO Model →
          </button>
        </div>
      </div>

      {/* Usage meter — placeholder */}
      <div className="section-h">
        <span className="ttl">Agent compute · usage</span>
        <span className="meta">V1.1 — billing telemetry pending</span>
      </div>
      <div
        className="callout"
        data-testid="subscription-usage-placeholder"
        style={{ alignItems: "center" }}
      >
        <div>
          <div className="ttl">Usage telemetry coming in V1.1</div>
          <div className="sub">
            Agent compute is metered server-side today. The customer-facing
            usage meter ships with the Pax8 billing tie-in.
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: 18,
          padding: "10px 12px",
          background: "var(--bg-soft)",
          fontSize: 11,
          color: "var(--text-3)",
          borderRadius: 6,
        }}
      >
        Need to change your plan? Contact your Pax8 reseller.
      </div>
    </div>
  );
}
